import { getRatingClass } from '@coderush/shared';
import { Link } from 'react-router-dom';

interface UserLinkProps {
  username: string;
  displayName?: string;
  rating?: number | null;
  showRating?: boolean;
}

/**
 * ユーザー名を rating class の色つきで表示する (SPEC 43)。
 * 色だけで情報を伝えないよう、rating 値も併記できるようにしている。
 */
export function UserLink({ username, displayName, rating, showRating = false }: UserLinkProps) {
  const ratingClass = getRatingClass(rating);
  return (
    <span className="u-row">
      <Link
        to={`/users/${encodeURIComponent(username)}`}
        className={`p-rating p-rating--${ratingClass.slug}`}
      >
        {displayName ?? username}
      </Link>
      {showRating && (
        <span className="u-faint u-text-sm u-mono">
          {rating === null || rating === undefined ? '—' : rating}
        </span>
      )}
    </span>
  );
}

export function RatingValue({ rating }: { rating: number | null | undefined }) {
  const ratingClass = getRatingClass(rating);
  return (
    <span className={`p-rating p-rating--${ratingClass.slug}`} title={ratingClass.name}>
      {rating === null || rating === undefined ? '—' : rating}
    </span>
  );
}
